import type { Service } from '@/services/firestore/types'

export const ADDON_BLOCK_TITLES: Record<string, string> = {
  designs: 'Designs',
  'per-nails': 'Per nail',
  'per-items': 'Per item',
  removal: 'Removal',
}

export const ADDON_BLOCK_ORDER = ['designs', 'per-nails', 'per-items', 'removal'] as const

export function parseAddOnBlockId(serviceId: string): string | null {
  if (!serviceId.startsWith('addon-')) {
    return null
  }

  const rest = serviceId.slice('addon-'.length)

  for (const blockId of ADDON_BLOCK_ORDER) {
    if (rest.startsWith(`${blockId}-`)) {
      return blockId
    }
  }

  return null
}

export function groupAddOnServices(services: Service[]) {
  const groups = new Map<string, Service[]>()

  for (const service of services) {
    const blockId = parseAddOnBlockId(service.id)
    if (!blockId) {
      continue
    }

    const rows = groups.get(blockId) ?? []
    rows.push(service)
    groups.set(blockId, rows)
  }

  for (const rows of groups.values()) {
    rows.sort((left, right) => left.displayOrder - right.displayOrder)
  }

  return groups
}
